import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Form, Input, Modal, Radio, Row } from 'antd';

const FormItem = Form.Item;
const Textarea = Input;

class IndexModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  submit = () => {
    const { data, orgUuid } = this.props;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        values.uuid = data ? data.uuid : '';
        values.orgUuid = orgUuid;
        this.props.onOk(values);
        this.props.form.resetFields();
      }
    });
  };

  onCancel = () => {
    this.props.form.resetFields();
    this.props.onCancel();
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { data } = this.props;
    const ItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
    return (
      <Modal
        title={data && data.uuid ? '编辑用户' : '创建用户'}
        visible={this.props.visible}
        onOk={this.submit}
        onCancel={this.onCancel}
      >
        <Form>
          <Row>
            <Col span={20}>
              <FormItem label="名称" {...ItemLayout}>
                {getFieldDecorator('name', {
                  rules: [{ required: true, message: '请输入名称!' }],
                  initialValue: data && data.uuid ? data.name : '',
                })(<Input placeholder="名称" />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={20}>
              <FormItem label="账户代码" {...ItemLayout}>
                {getFieldDecorator('code', {
                  rules: [{ required: true, message: '请输入账户代码!' }],
                  initialValue: data && data.uuid ? data.code : '',
                })(<Input placeholder="代码" />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={20}>
              <FormItem label="状态" {...ItemLayout}>
                {getFieldDecorator('status', {
                  rules: [{ required: true, message: '请选择状态!' }],
                  initialValue: data && data.uuid ? data.status : 1,
                })(
                  <Radio.Group>
                    <Radio value={1}>启用</Radio>
                    <Radio value={0}>禁用</Radio>
                  </Radio.Group>,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={20}>
              <FormItem label="备注" {...ItemLayout}>
                {getFieldDecorator('remark', {
                  initialValue: data && data.uuid ? data.remark : '',
                })(<Textarea placeholder="备注" />)}
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  }
}

export default connect(state => ({
  accountInfo: state.account_info,
}))(Form.create()(IndexModal));



// WEBPACK FOOTER //
// ./src/components/boss/user/ModalUserAdd.js